import React, { useState } from 'react';
import api from '../api/client';

interface StorageCellProps {
  entity: any;
  type: 'user' | 'company';
  onUpdate: () => void;
}

export default function StorageCell({ entity, type, onUpdate }: StorageCellProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);

  const used = Number(entity.storageUsed) || 0;
  const limit = Number(entity.storageLimit) || 1;
  const percent = Math.min(100, Math.round((used / limit) * 100));

  let color = '#10b981'; // зелёный
  if (percent > 90) color = '#ef4444'; // красный
  else if (percent > 70) color = '#f59e0b'; // жёлтый

  const handleOpen = () => {
    setInputValue(String(Math.round(limit / 1048576)));
    setIsOpen(true);
  };

  const handleSave = async () => {
    const val = Number(inputValue);
    if (isNaN(val) || val < 0) {
      alert('Введите корректное число');
      return;
    }
    setLoading(true);
    try {
      const url = type === 'user'
        ? '/users/' + entity.id + '/storage-limit'
        : '/companies/' + entity.id + '/storage-limit';
      await api.put(url, { storageLimit: val * 1048576 });
      setIsOpen(false);
      onUpdate();
    } catch (e: any) {
      alert('Ошибка сохранения: ' + (e.message || 'неизвестная'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          cursor: 'pointer',
          minWidth: 130,
        }}
        onClick={handleOpen}
        title={'Использовано: ' + (used / 1048576).toFixed(2) + ' МБ из ' + (limit / 1048576).toFixed(0) + ' МБ. Кликните, чтобы изменить лимит.'}
      >
        <div
          style={{
            width: 50,
            height: 8,
            background: '#e2e8f0',
            borderRadius: 4,
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <div style={{ width: percent + '%', height: '100%', background: color }} />
        </div>
        <span style={{ fontSize: 11, color: '#64748b', whiteSpace: 'nowrap' }}>
          {(used / 1048576).toFixed(1)} / {(limit / 1048576).toFixed(0)} МБ
        </span>
      </div>

      {/* Модальное окно */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={() => setIsOpen(false)}
        >
          <div
            style={{
              background: 'white',
              padding: 24,
              borderRadius: 12,
              width: 340,
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: '0 0 8px 0', fontSize: 18, fontWeight: 600 }}>
              Лимит хранилища
            </h3>
            <p style={{ margin: '0 0 16px 0', fontSize: 14, color: '#666' }}>
              {type === 'user' ? (entity.name || entity.email) : entity.name}
            </p>
            <label style={{ display: 'block', fontSize: 13, marginBottom: 6, fontWeight: 500 }}>
              Лимит (МБ):
            </label>
            <input
              type="number"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ddd',
                borderRadius: 8,
                fontSize: 14,
                marginBottom: 16,
                boxSizing: 'border-box',
              }}
              autoFocus
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  padding: '8px 16px',
                  borderRadius: 8,
                  border: '1px solid #ddd',
                  background: 'white',
                  cursor: 'pointer',
                  fontSize: 14,
                }}
              >
                Отмена
              </button>
              <button
                onClick={handleSave}
                disabled={loading}
                style={{
                  padding: '8px 16px',
                  borderRadius: 8,
                  border: 'none',
                  background: '#2575fc',
                  color: 'white',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontSize: 14,
                  fontWeight: 600,
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? 'Сохранение...' : 'Сохранить'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
